import { createElementVNode as _createElementVNode, resolveComponent as _resolveComponent, normalizeClass as _normalizeClass, withCtx as _withCtx, createVNode as _createVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"
import _imports_0 from '@/assets/images/tab_shouye.png'
import _imports_1 from '@/assets/images/tab_shouye_low.png'
import _imports_2 from '@/assets/images/tab_luntan.png'
import _imports_3 from '@/assets/images/tab_luntan_low.png'
import _imports_4 from '@/assets/images/tab_gongnue.png'
import _imports_5 from '@/assets/images/tab_gongnue_low.png'
import _imports_6 from '@/assets/images/tab_my_low.png'
import _imports_7 from '@/assets/images/tab_my.png'


const _withScopeId = n => (_pushScopeId("data-v-7b64e318"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "menueBox" }
const _hoisted_2 = { class: "menueDiv" }
const _hoisted_3 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("img", {
  class: "high",
  src: _imports_0
}, null, -1))
const _hoisted_4 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("img", {
  class: "default",
  src: _imports_1
}, null, -1))
const _hoisted_5 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("img", {
  class: "high",
  src: _imports_2
}, null, -1))
const _hoisted_6 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("img", {
  class: "default",
  src: _imports_3
}, null, -1))
const _hoisted_7 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("img", {
  class: "high",
  src: _imports_4
}, null, -1))
const _hoisted_8 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("img", {
  class: "default",
  src: _imports_5
}, null, -1))
const _hoisted_9 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("img", {
  class: "default",
  src: _imports_6
}, null, -1))
const _hoisted_10 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("img", {
  class: "high",
  src: _imports_7
}, null, -1))

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_router_link = _resolveComponent("router-link")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("div", _hoisted_2, [
      _createVNode(_component_router_link, {
        to: "/",
        class: _normalizeClass(["menueItem", _ctx.current=='home'?'current':'']),
        replace: ""
      }, {
        default: _withCtx(() => [
          _hoisted_3,
          _hoisted_4
        ]),
        _: 1
      }, 8, ["class"]),
      _createVNode(_component_router_link, {
        to: "/luntang",
        replace: "",
        class: _normalizeClass(["menueItem", _ctx.current=='luntang'?'current':''])
      }, {
        default: _withCtx(() => [
          _hoisted_5,
          _hoisted_6
        ]),
        _: 1
      }, 8, ["class"]),
      _createVNode(_component_router_link, {
        to: "/gongnue",
        replace: "",
        class: _normalizeClass(["menueItem", _ctx.current=='gongnue'?'current':''])
      }, {
        default: _withCtx(() => [
          _hoisted_7,
          _hoisted_8
        ]),
        _: 1
      }, 8, ["class"]),
      _createVNode(_component_router_link, {
        to: "/my",
        replace: "",
        class: _normalizeClass(["menueItem", _ctx.current=='my'?'current':''])
      }, {
        default: _withCtx(() => [
          _hoisted_9,
          _hoisted_10
        ]),
        _: 1
      }, 8, ["class"])
    ])
  ]))
}